(function (root) {
  function isElement(node) {
    return !!(node && node.nodeType === 1);
  }

  function nextElement(node) {
    var cursor = node ? node.nextSibling : null;
    while (cursor && cursor.nodeType !== 1) cursor = cursor.nextSibling;
    return cursor;
  }

  function isHeading(el) {
    return isElement(el) && /^H[2-6]$/i.test(el.tagName);
  }

  function headingLevel(el) {
    var match = String((el && el.tagName) || "").match(/^H([2-6])$/i);
    return match ? Number(match[1]) : 99;
  }

  function normalizedText(el) {
    return String((el && el.textContent) || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function isFaqParagraph(el) {
    if (!isElement(el) || !/^P$/i.test(el.tagName)) return false;
    var first = el.firstElementChild;
    if (!first || !/^(STRONG|B)$/i.test(first.tagName)) return false;
    var text = normalizedText(first);
    return text.charAt(text.length - 1) === "?";
  }

  function isFaqTitle(el) {
    if (!isHeading(el)) return false;
    var text = normalizedText(el).toLowerCase();
    return /h[aä]ufige fragen|\bfaq\b|fragen zum |fragen zur |fragen über /.test(text);
  }

  function isQuestionHeading(el) {
    if (!isHeading(el)) return false;
    var text = normalizedText(el);
    return text.charAt(text.length - 1) === "?";
  }

  function collectHeadingAnswer(questionEl, faqTitleEl) {
    var nodes = [];
    var parts = [];
    var cursor = nextElement(questionEl);
    var titleLevel = headingLevel(faqTitleEl);
    var questionLevel = headingLevel(questionEl);
    while (cursor) {
      if (isQuestionHeading(cursor) || isFaqParagraph(cursor) || isFaqTitle(cursor)) break;
      if (isHeading(cursor) && headingLevel(cursor) <= Math.min(titleLevel, questionLevel)) break;
      nodes.push(cursor);
      var text = normalizedText(cursor);
      if (text) parts.push(text);
      cursor = nextElement(cursor);
    }
    return { nodes: nodes, text: parts.join(" "), next: cursor };
  }

  function extractStrongItems(headingEl) {
    var items = [];
    var nodes = [headingEl];
    var cursor = nextElement(headingEl);
    while (isFaqParagraph(cursor)) {
      var strong = cursor.firstElementChild;
      var question = normalizedText(strong);
      var full = normalizedText(cursor);
      var answer = full.indexOf(question) === 0 ? full.slice(question.length).trim() : full;
      items.push({ question: question, answer: answer, paragraph: cursor });
      nodes.push(cursor);
      cursor = nextElement(cursor);
    }
    return { items: items, nodes: nodes };
  }

  function extractHeadingItems(headingEl) {
    var items = [];
    var nodes = [headingEl];
    var cursor = nextElement(headingEl);
    while (isQuestionHeading(cursor)) {
      var question = normalizedText(cursor);
      nodes.push(cursor);
      var collected = collectHeadingAnswer(cursor, headingEl);
      collected.nodes.forEach(function (node) {
        nodes.push(node);
      });
      items.push({ question: question, answer: collected.text, paragraph: cursor });
      cursor = collected.next;
    }
    return { items: items, nodes: nodes };
  }

  function extractFrom(source) {
    var faqHeading = null;
    var items = [];
    var faqNodes = [];
    if (!source) return { faqHeading: faqHeading, items: items, faqNodes: faqNodes };

    var children = Array.prototype.slice.call(source.children || []);
    children.forEach(function (el) {
      if (faqHeading) return;
      var next = nextElement(el);
      var extracted = null;
      if (isHeading(el) && isFaqParagraph(next)) {
        extracted = extractStrongItems(el);
      } else if (isFaqTitle(el) && isQuestionHeading(next)) {
        extracted = extractHeadingItems(el);
      }
      if (!extracted || !extracted.items.length) return;
      faqHeading = el;
      items = extracted.items;
      faqNodes = extracted.nodes;
    });

    return { faqHeading: faqHeading, items: items, faqNodes: faqNodes };
  }

  function splitSeo(source, faqNodes) {
    var skip = {};
    (faqNodes || []).forEach(function (node, index) {
      skip[index] = node;
    });
    var remaining = Array.prototype.slice.call(source.children || []).filter(function (el) {
      if (faqNodes.indexOf(el) !== -1) return false;
      if (isHeading(el) && !normalizedText(el)) return false;
      return true;
    });
    var title = null;
    if (remaining[0] && isHeading(remaining[0])) title = remaining.shift();
    var blocks = [];
    var current = [];
    remaining.forEach(function (el) {
      if (isHeading(el) && current.length) {
        blocks.push(current);
        current = [el];
      } else {
        current.push(el);
      }
    });
    if (current.length) blocks.push(current);
    var mid = Math.ceil(blocks.length / 2);
    return { title: title, left: blocks.slice(0, mid), right: blocks.slice(mid) };
  }

  function iconMarkup() {
    return (
      '<span class="fh-collection-content__icon" aria-hidden="true">' +
      '<svg class="fh-collection-content__icon-plus" viewBox="0 0 16 16" width="22" height="22" focusable="false">' +
      '<path d="M8 3v10M3 8h10" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square"/>' +
      "</svg>" +
      '<svg class="fh-collection-content__icon-minus" viewBox="0 0 16 16" width="22" height="22" focusable="false">' +
      '<path d="M3 8h10" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square"/>' +
      "</svg>" +
      "</span>"
    );
  }

  function renderFaq(list, items) {
    if (!list) return;
    list.innerHTML = "";
    items.forEach(function (item, index) {
      var details = document.createElement("details");
      details.className = "fh-collection-content__item";
      if (index === 0) details.open = true;
      var summary = document.createElement("summary");
      summary.className = "fh-collection-content__question";
      var label = document.createElement("span");
      label.textContent = item.question;
      summary.appendChild(label);
      summary.insertAdjacentHTML("beforeend", iconMarkup());
      var answer = document.createElement("div");
      answer.className = "fh-collection-content__answer";
      var p = document.createElement("p");
      p.textContent = item.answer;
      answer.appendChild(p);
      details.appendChild(summary);
      details.appendChild(answer);
      list.appendChild(details);
    });
  }

  function injectJsonLd(section, items) {
    if (!section || !items.length) return;
    section.querySelectorAll('script[data-fh-faq-jsonld]').forEach(function (node) {
      node.remove();
    });
    var payload = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map(function (item) {
        return {
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer
          }
        };
      })
    };
    var script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-fh-faq-jsonld", "true");
    script.textContent = JSON.stringify(payload);
    section.appendChild(script);
  }

  function appendBlocks(column, blocks) {
    if (!column) return;
    blocks.forEach(function (block) {
      var wrap = document.createElement("div");
      wrap.className = "fh-collection-content__block";
      block.forEach(function (node) {
        wrap.appendChild(node);
      });
      column.appendChild(wrap);
    });
  }

  function init(section) {
    if (!section) return;
    var source = section.querySelector("[data-fh-source]");
    var seo = section.querySelector("[data-fh-seo]");
    // INT-0027: Wenn serverseitig eine Metaobjekt-FAQ gerendert wurde (data-fh-faq-server) oder die
    // Section hart auf "metaobjects_only" steht, darf der alte JS-Pfad niemals eine eigene FAQ-UI
    // rendern oder JSON-LD injizieren - auch nicht als Fallback bei leerer custom.faqs-Liste.
    var faqServerRendered = !!section.querySelector("[data-fh-faq-server]");
    var faqSourceMode = (section.dataset && section.dataset.faqSource) || "auto";
    var faq = faqServerRendered || faqSourceMode === "metaobjects_only" ? null : section.querySelector("[data-fh-faq]");
    if (!source) return;

    var extracted = extractFrom(source);
    var split = splitSeo(source, extracted.faqNodes);
    if (seo) {
      var titleHost = seo.querySelector("[data-fh-seo-title]");
      var left = seo.querySelector('[data-fh-seo-col="0"]');
      var right = seo.querySelector('[data-fh-seo-col="1"]');
      if (titleHost && split.title) {
        // Reuse the server-normalized heading; moving nodes preserves H2/H3/H4
        // semantics and their independent typography without duplicating content.
        split.title.classList.add("fh-collection-content__seo-heading");
        titleHost.replaceWith(split.title);
      } else if (titleHost && !split.title) {
        titleHost.remove();
      }
      appendBlocks(left, split.left);
      appendBlocks(right, split.right);
      seo.hidden = false;
    }
    source.hidden = true;

    if (faq) {
      if (extracted.items.length) {
        var headingHost = faq.querySelector("[data-fh-faq-heading]");
        var list = faq.querySelector("[data-fh-faq-list]");
        if (headingHost && extracted.faqHeading) {
          extracted.faqHeading.classList.add("fh-collection-content__faq-heading");
          headingHost.replaceWith(extracted.faqHeading);
        }
        renderFaq(list, extracted.items);
        injectJsonLd(section, extracted.items);
        faq.hidden = false;
        if (typeof root.fhBindExclusiveAccordion === "function") {
          root.fhBindExclusiveAccordion(faq);
        }
      } else {
        faq.hidden = true;
      }
    }
  }

  function initAll(scope) {
    var rootEl = scope || root.document;
    if (!rootEl || !rootEl.querySelectorAll) return;
    rootEl.querySelectorAll("[data-fh-collection-content]").forEach(init);
  }

  root.FHCollectionContent = {
    extractFrom: extractFrom,
    splitSeo: splitSeo,
    isFaqParagraph: isFaqParagraph,
    isFaqTitle: isFaqTitle,
    isQuestionHeading: isQuestionHeading,
    init: init,
    initAll: initAll
  };

  if (root.document) {
    if (root.document.readyState === "loading") {
      root.document.addEventListener("DOMContentLoaded", function () {
        initAll(root.document);
      });
    } else {
      initAll(root.document);
    }
    root.document.addEventListener("shopify:section:load", function (event) {
      initAll(event.target);
    });
  }
})(typeof window !== "undefined" ? window : globalThis);
